<template>
  <v-container>
    <v-row>
      <v-col :cols="12">
        <div class="title-container">
          <div class="font-weight-bold mt-10 title-page">Minha Conta</div>
          <div v-if="user" class="button-group">
            <v-btn v-if="isRegistrationCNPJ" type="button" elevation="0" color="primary" outlined
              to="/representantes">Representantes</v-btn>
            <v-btn type="button" elevation="0" color="primary" @click="profileModal = true">Editar</v-btn>
            <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined to="/home">Voltar</v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <br />

    <div class="mt-4" v-if="dataset.loading">
      <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
    </div>

    <div v-if="!dataset.loading" v-html="!user ? dataset.contentUserAnonymous : ''"></div>

    <v-row v-if="user">
      <v-col cols="12">
        <v-card class="card-form-outlined">
          <v-card-title class="card-group-title">Detalhes</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <span class="main-text"> {{ user ? user.name : '' }} </span>
                <div class="caption-text">NOME COMPLETO</div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="main-text"> {{ user ? user.phone_number : '' }} </span>
                <div class="caption-text">TELEFONE</div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="main-text"> {{ user ? formatCpfCnpj(user.registration) : '' }} </span>
                <div class="caption-text">CPF/CNPJ</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4">
                <span class="main-text"> {{ user ? user.email : '' }} </span>
                <div class="caption-text">EMAIL</div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="main-text"> {{ user ? user.nationality : '' }} </span>
                <div class="caption-text">NACIONALIDADE</div>
              </v-col>
              <v-col cols="12" sm="4" class="d-flex align-center pt-4">
                <v-checkbox v-if="user && isRegistrationCNPJ && !!user.is_financial_institution" :input-value="true"
                  label="Instituição Financeira" dense hide-details disabled class="mr-4 mt-0" />
                <v-checkbox v-if="user && isRegistrationCNPJ && !!user.is_me_epp" :input-value="true" label="ME/EPP"
                  dense hide-details disabled class="mt-0" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="user">
      <v-col cols="12">
        <v-card class="card-form-outlined">
          <v-card-title class="card-group-title">
            Documentos
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <div class="mb-2 caption-text">
                  {{ isRegistrationCNPJ ? 'CONTRATO SOCIAL' : 'DOCUMENTO DE IDENTIFICAÇÃO' }}
                </div>

                <v-btn v-if="user && user.documentUrl" small color="primary" outlined :href="user.documentUrl"
                  target="_blank">
                  <v-icon left small>mdi-eye</v-icon>
                  Visualizar
                </v-btn>

                <span v-else class="caption-text grey--text">
                  Documento não disponível
                </span>
              </v-col>

              <v-col v-if="user && user.otherDocuments && user.otherDocuments.length > 0" cols="12" sm="4">
                <div class="mb-2 caption-text text-uppercase">
                  Outros documentos
                </div>

                <v-btn small color="primary" outlined @click="otherDocsModal = true">
                  <v-icon left small>mdi-folder</v-icon>
                  Ver documentos
                </v-btn>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="user">
      <v-col cols="12">
        <v-card class="card-form-outlined">
         <v-card-title class="card-group-title d-flex justify-space-between">
            <span>
              {{ user && user.is_international_address == 1 ? 'Address' : 'Endereço' }}
            </span>
            <v-chip v-if="user && user.is_international_address == 1" small color="primary" outlined label
              class="font-weight-bold">
              ENDEREÇO FORA DO BRASIL
            </v-chip>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <span class="main-text"> {{ user ? user.address_postal_code : '' }} </span>
                <div class="caption-text">
                  {{ user && user.is_international_address == 1 ? 'ZIP CODE' : 'CEP' }}
                </div>
              </v-col>
              <v-col cols="12" sm="8">
                <span class="main-text"> {{ user ? user.address_street : '' }} </span>
                <div class="caption-text">
                  {{ user && user.is_international_address == 1 ? 'STREET / ADDRESS' : 'RUA/AVENIDA' }}
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4">
                <span class="main-text"> {{ user ? user.address_number : '' }} </span>
                <div class="caption-text">
                  {{ user && user.is_international_address == 1 ? 'NUMBER' : 'NÚMERO' }}
                </div>
              </v-col>
              <v-col cols="12" sm="8">
                <span class="main-text"> {{ user ? (user.address_complement || '-') : '-' }} </span>
                <div class="caption-text">
                  {{ user && user.is_international_address == 1 ? 'SUITE / APT / UNIT' : 'COMPLEMENTO' }}
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4">
                <span class="main-text"> {{ user ? user.address_neighborhood : '' }} </span>
                <div class="caption-text">
                  {{ user && user.is_international_address == 1 ? 'DISTRICT / REGION' : 'BAIRRO' }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="main-text"> {{ user ? user.address_city : '' }} </span>
                <div class="caption-text">
                  {{ user && user.is_international_address == 1 ? 'CITY' : 'CIDADE' }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="main-text"> {{ user ? user.address_state : '' }} </span>
                <div class="caption-text">
                  {{ user && user.is_international_address == 1 ? 'STATE / PROVINCE' : 'ESTADO' }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="
      user &&
      isRegistrationCNPJ &&
      Array.isArray(user.representatives) &&
      user.representatives.length > 0
    ">
      <v-col class="mb-n8" cols="12" v-for="(rep, index) in user.representatives" :key="rep.id || index">
        <v-card class="card-form-outlined mb-4">
          <v-card-title class="card-group-title">
            Representante - {{ index + 1 }}
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <span class="main-text">{{ rep.name }}</span>
                <div class="caption-text">NOME</div>
              </v-col>

              <v-col cols="12" sm="4">
                <span class="main-text">
                  {{ formatCpfCnpj(rep.registration) }}
                </span>
                <div class="caption-text">CPF/CNPJ</div>
              </v-col>

              <v-col v-if="rep.status !== null && rep.status !== undefined" cols="12" sm="4"
                class="d-flex flex-column align-start">
                <div class="d-flex align-center mb-1">
                  <v-chip :color="getRepStatusColor(rep.status)" text-color="white" small>
                    {{ getRepStatusText(rep.status) }}
                  </v-chip>

                  <v-tooltip bottom v-if="rep.status === 2">
                    <template #activator="{ on, attrs }">
                      <v-btn icon small class="ml-2" v-on="on" v-bind="attrs" @click="openRejectReason(rep)">
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar motivo da rejeição</span>
                  </v-tooltip>
                </div>

                <div class="caption-text ml-4">STATUS</div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-row class="mt-3">
            <v-col cols="12">
              <v-btn v-if="rep.documentUrl" small class="ml-5 mt-n15" color="primary" outlined :href="rep.documentUrl"
                target="_blank" rel="noopener">
                <v-icon left small>mdi-eye</v-icon>
                Visualizar documento
              </v-btn>

              <span v-else class="caption-text grey--text ml-5">
                Documento não disponível
              </span>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else-if="
      user &&
      isRegistrationCNPJ &&
      (!Array.isArray(user.representatives) ||
        user.representatives.length === 0)
    ">
      <v-col cols="12">
        <v-alert type="info" outlined>
          Nenhum representante foi encontrado para este cadastro.
        </v-alert>
      </v-col>
    </v-row>

    <v-row v-if="user" text-align="center">
      <v-col cols="12">
        <v-card class="card-form-outlined">
          <v-card-title class="card-group-title d-flex align-center">
            Procurador
            <v-spacer />
            <v-btn small color="primary" to="/associacao-procurador">
              {{ userLawyerData && userLawyerData.lawyer ? 'Acompanhar associação' : 'Associar procurador' }}
            </v-btn>
          </v-card-title>
          <v-card-text>
            <template v-if="userLawyerData && userLawyerData.lawyer">
              <v-row>
                <v-col cols="12" sm="4">
                  <span class="main-text">{{
                    userLawyerData.lawyer.name || 'N/A'
                    }}</span>
                  <div class="caption-text">NOME</div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="main-text">{{
                    formatCpfCnpj(userLawyerData.lawyer.registration) || 'N/A'
                    }}</span>
                  <div class="caption-text">CPF</div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="main-text">{{
                    userLawyerData.lawyer.federal_registration || 'N/A'
                    }}</span>
                  <div class="caption-text">NÚMERO OAB</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4">
                  <span class="main-text">{{
                    userLawyerData.lawyer.federal_registration_uf || 'N/A'
                    }}</span>
                  <div class="caption-text">OAB UF</div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="main-text">{{
                    userLawyerData.lawyer.email || 'N/A'
                    }}</span>
                  <div class="caption-text">E-MAIL</div>
                </v-col>

                <v-col v-if="userLawyerData && userLawyerData.lawyer" cols="12" sm="4"
                  class="d-flex flex-column align-start">
                  <div class="d-flex align-center mb-1">

                    <v-chip :color="getColorByStatus(userLawyerData.status)" text-color="white" small>
                      {{ getTextByStatus(userLawyerData.status) }}
                    </v-chip>

                    <v-tooltip bottom v-if="[4, 5].includes(userLawyerData.status)">
                      <template #activator="{ on, attrs }">

                        <v-btn icon small class="ml-5 pulse-attention" v-on="on" v-bind="attrs"
                          @click="handleLawyerAction(userLawyerData.status)">
                          <v-icon medium :color="getLawyerActionColor(userLawyerData.status)">
                            {{ getLawyerActionIcon(userLawyerData.status) }}
                          </v-icon>
                        </v-btn>

                      </template>

                      <span>{{ getLawyerActionTooltip(userLawyerData.status) }}</span>
                    </v-tooltip>

                  </div>

                  <div class="caption-text ml-4">STATUS</div>
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="3" v-if="userLawyerData.lawyer.documentUrl">
                  <v-btn type="button" elevation="0" small color="primary" outlined :href="userLawyerData.lawyer.documentUrl"
                    target="_blank">
                     <v-icon left small>mdi-eye</v-icon>
                    Visualizar documento
                  </v-btn>
                </v-col>
                <v-col cols="3" v-if="userLawyerData.documentUrl">
                  <v-btn type="button" elevation="0" small color="primary" outlined :href="userLawyerData.documentUrl"
                    target="_blank">
                   <v-icon left small>mdi-eye</v-icon>
                    Visualizar documento
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3" v-if="userLawyerData.lawyer.documentUrl">
                  <iframe :src="userLawyerData.lawyer.documentUrl" width="250" height="150" frameborder="0"
                    scrolling="no" class="rounded-xl"></iframe>
                  <div class="caption-text">DOCUMENTO OAB</div>
                </v-col>
                <v-col cols="3" v-if="userLawyerData.documentUrl">
                  <iframe :src="userLawyerData.documentUrl" width="250" height="150" frameborder="0" scrolling="no"
                    class="rounded-xl"></iframe>
                  <div class="caption-text">DOCUMENTO PROCURAÇÃO</div>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row>
                <v-col cols="12" text-align="center">
                  <span class="main-text">Nenhum procurador encontrado</span>
                </v-col>
              </v-row>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showUpdateProcurationDialog" max-width="600px">
      <v-card>
        <v-card-title class="font-weight-bold primary--text justify-space-between mb-4">
          Enviar procuração
        </v-card-title>
        <v-card-text>

          <p>Documento de procuração pendente. Selecione e envie o documento de
            procuração que foi gerado e assinado digitalmente via plataforma GOV.BR.</p>

          <v-form>
            <v-row>
              <v-col>
                <v-file-input dense accept="application/pdf" prepend-icon="" outlined counter required
                  :rules="[$rules.fileSize(4)]" show-size truncate-length="50"
                  hint="O arquivo não pode ser superior a 4MB" hide-details="auto" label="Documento procuração"
                  :clearable="true" v-model="dataset.procuration_file" @change="onProcurationFileChange"
                  ref="procuration_file" />
              </v-col>
            </v-row>

            <br>
            <v-btn color="primary" type="submit" @click="updateProcurationFile" :loading="loadingPdf">Enviar</v-btn>
            <v-btn text class="grey--text" @click="showUpdateProcurationDialog = false">Cancelar</v-btn>

          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>


    <!-- Modal gerar novamente procuração padrão -->
    <v-dialog v-model="showGenerateProcurationDialog" max-width="800px" persistent>
      <v-card>
        <v-card-title class="font-weight-bold primary--text justify-space-between mb-4">
          Adicionar/Associar Procurador
        </v-card-title>

        <v-card-text v-if="dataset.showForm">

          Preencha os campos abaixo com os dados do procurador.
          <br>
          <br>
          <v-form ref="form" v-model="validForm">
            <v-row>
              <v-col>
                <v-text-field dense id="name" label="Nome completo" v-model="dataset.procurator.name" required
                  :rules="[$rules.required]" outlined hide-details="auto" />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field dense id="procurator_registration" label="CPF" v-model="dataset.procurator.registration"
                  required :rules="[$rules.required, $rules.cpf]" outlined hide-details="auto"
                  v-mask="['###.###.###-##']">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field dense label="Telefone" v-model="dataset.procurator.phone_number" required outlined
                  :rules="[$rules.required]" hide-details="auto">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field dense id="federal_registration" label="Número OAB"
                  v-model="dataset.procurator.federal_registration" required
                  :rules="[$rules.required, $rules.alphaNumeric]" outlined hide-details="auto">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-autocomplete dense required :items="dataset.statesList" label="OAB UF"
                  v-model="dataset.procurator.federal_registration_uf" item-value="name" item-text="name"
                  :rules="[$rules.required]" outlined hide-details="auto">
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field dense id="address_postal_code" label="CEP"
                  v-model="dataset.procurator.address_postal_code" required :rules="[$rules.required, $rules.cep]"
                  outlined hide-details="auto" v-mask="'##.###-###'" @blur="searchCep"></v-text-field>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field dense id="address_street" label="Rua/Avenida" v-model="dataset.procurator.address_street"
                  required :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field dense id="address_number" label="Número" v-model="dataset.procurator.address_number"
                  required :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field dense id="address_complement" label="Complemento"
                  v-model="dataset.procurator.address_complement" outlined hide-details="auto"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field dense id="address_neighborhood" label="Bairro"
                  v-model="dataset.procurator.address_neighborhood" required :rules="[$rules.required]" outlined
                  hide-details="auto"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field dense id="address_city" label="Cidade" v-model="dataset.procurator.address_city" required
                  :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4">
                <v-autocomplete dense id="address_state" label="Estado" :items="dataset.statesList" item-text="name"
                  item-value="sigla" v-model="dataset.procurator.address_state" required :rules="[$rules.required]"
                  outlined hide-details="auto"></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="8">
                <v-text-field dense class="mb-2" id="email" label="E-mail" v-model="dataset.procurator.email" required
                  :rules="[$rules.required, $rules.email]" outlined hide-details="auto" />
              </v-col>

            </v-row>
            <v-row>
              <v-col>
                <v-file-input dense accept="image/png, image/jpeg, application/pdf" prepend-icon="" outlined counter
                  required :rules="[$rules.required, $rules.fileSize(4)]" show-size truncate-length="70"
                  hint="O arquivo não pode ser superior a 4MB" hide-details="auto"
                  label="Documento de identificação (CPF, RG ou CNH)" :clearable="true" @change="onFileSelected($event)"
                  ref="procurator_file" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-text v-if="dataset.showForm">
          <v-btn color="primary" @click="createProcuration" :loading="loading">Gerar procuração</v-btn>
          <v-btn text class="grey--text" @click="showGenerateProcurationDialog = false">Cancelar</v-btn>
        </v-card-text>

        <v-divider class="my-3" v-if="procurationHtml"></v-divider>

        <v-card-text v-if="procurationHtml">
          <p class="subtitle-1 font-weight-bold mb-2">Pré-visualização da Procuração</p>

          <div class="scroll-box" v-html="procurationHtml"></div>

          <v-btn color="success" class="mt-4" @click="generateProcurationPdf" :loading="loadingPdf">
            Gerar PDF Procuração
          </v-btn>
          <v-btn color="primary" class="mt-4 ml-5" @click="editProcuration" :loading="loading">
            Editar Procuração
          </v-btn>

          <v-btn class="grey--text mt-4 ml-5" @click="showGenerateProcurationDialog = false">
            Cancelar
          </v-btn>
        </v-card-text>
      </v-card>

    </v-dialog>

    <!-- Modal com o motivo completo -->
    <user-profile-edit-modal v-model="profileModal" @saved="handleProfileSaved" />

    <v-dialog v-if="user" v-model="showReasonDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Motivo da rejeição</v-card-title>
        <v-card-text>
          {{ selectedRejectReason || 'Nenhum motivo informado.' }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showReasonDialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="otherDocsModal" max-width="600">
      <v-card>
        <v-card-title class="headline">
          Outros Documentos
        </v-card-title>

        <v-divider />

        <v-card-text>
          <v-list dense>
            <v-list-item v-for="(doc, index) in user && user.otherDocuments " :key="index">
              <v-list-item-content>
                <v-list-item-title>
                  {{ doc.name || doc.type || 'Documento' }}
                </v-list-item-title>

                <v-list-item-subtitle class="caption grey--text">
                  Criado em:
                  {{ formatDate(doc.created_at) }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" :href="doc.documentUrl" target="_blank" rel="noopener">
                      <v-icon color="primary">mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar documento</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <div v-if="user && (!user.otherDocuments || user.otherDocuments.length === 0)"
            class="text-center grey--text caption">
            Nenhum documento disponível
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="otherDocsModal = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
import 'moment/locale/pt-br'
import { eventHub } from '@/main'
import { cpf, cnpj } from 'cpf-cnpj-validator'
import axios from 'axios'
import statesList from "@/common/data/states-list.data";
import string from "@/common/util/string";
import UserProfileEditModal from '@/components/creditor/UserProfileEditModal.vue'

export default {
  components: { UserProfileEditModal },
  data: () => ({
    user: null,
    validForm: false,
    showReasonDialog: false,
    showUpdateProcurationDialog: false,
    showGenerateProcurationDialog: false,
    userLawyerData: null,
    selectedRejectReason: null,
    loading: false,
    otherDocsModal: false,
    profileModal: false,
    isRegistrationCNPJ: null,
    dataset: {
      contentUserAnonymous: '',
      contentUserLogged: '',
      loading: false,
      showForm: false,
      statesList: statesList,
      data: {
        items: [],
        client: null
      },
      procurator: {
        name: '',
        registration: '',
        phone_number: '',
        email: '',
        address_street: '',
        address_number: '',
        address_complement: '',
        address_neighborhood: '',
        address_city: '',
        address_postal_code: '',
        address_state: null
      }
    },
    selectedDoc: null,
    dialogViewDoc: false,
    processes: [],
    loadingPdf: false,
    procurationHtml: '',

  }),

  created() {
    this.$ga.event({
      eventCategory: 'page',
      eventAction: 'action',
      eventLabel: 'click',
      eventValue: 'user-area'
    })

    this.loadData()
  },

  methods: {
    async handleProfileSaved() {
      await this.loadUserInfo()
    },
    async loadData() {
      this.dataset.loading = true

      try {
        await this.loadText()
        if (this.$root.user) {
          await this.verifyAssociation()
          await this.loadUserInfo()
          await this.load()
        }
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataset.loading = false
      }
    },

    formatDate(date) {
      if (!date) {
        return '-';
      }

      return new Date(date).toLocaleDateString('pt-BR');
    },

    onFileSelected(file) {
      this.dataset.procurator.file = file
    },

    async onProcurationSelected(event) {
     const file = event.target.files[0];

      if (!file) return;

      if (file.type !== "application/pdf") {
        this.$dialog.notify.error("O arquivo precisa ser um PDF válido.");
        return;
      }

      this.dataset.data.procuration_file = file;

      //await this.uploadProcuration();
    },

    async createProcuration() {

      const isValid = await this.$refs.form.validate()
      if (!isValid) return

      const proceedAction = await this.$dialog.confirm({
        text: 'Deseja gerar o texto da procuração?',
        title: 'Gerar Procuração',
        actions: {
          false: 'Cancelar',
          true: 'Gerar'
        }
      });

      if (!proceedAction) return;

      const payload = this.buildProcuratorPayload();

      this.procurationHtml = null;

      this.loading = true

      try {
        const response = await axios.post('/api/users/create-template', payload)
        
        console.log("Resposta API: ", response)

        this.procurationHtml = response.data.content.content.template

        if(this.procurationHtml){
          this.dataset.showForm = false;
        }
        
      } catch (error) {
      
        console.error("Erro ao gerar texto da procuração:", error);

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.content &&
          error.response.data.content.error &&
          error.response.data.content.error.message
        ) {
          this.$dialog.notify.error(error.response.data.content.error.message, { position: 'top-right', timeout: 5000 });
        } else if (error && error.message) {
          this.$dialog.notify.error(error.message, { position: 'top-right', timeout: 5000 });
        } else {
          this.$dialog.notify.error("Erro ao gerar texto da procuração!", { position: 'top-right', timeout: 5000 });
        }
        
      } finally {
        this.loading = false
      }
    },

    buildProcuratorPayload() {
      const formData = new FormData()

      formData.append('procurator_name', this.dataset.procurator.name)

      if (this.dataset.procurator.registration) {
        const cleanRegistration = string.sanitizeCpfCnpj(this.dataset.procurator.registration)
        formData.append('procurator_registration', cleanRegistration)
      }

      formData.append('procurator_email', this.dataset.procurator.email)
      formData.append('procurator_phone_number', this.dataset.procurator.phone_number)
      formData.append('procurator_federal_registration', this.dataset.procurator.federal_registration)
      formData.append('procurator_federal_registration_uf', this.dataset.procurator.federal_registration_uf)
      formData.append('procurator_address_postal_code', (this.dataset.procurator.address_postal_code || '').replace(/\D/g, ''));
      //formData.append('procurator_address_postal_code', this.dataset.procurator.address_postal_code)
      formData.append('procurator_address_street', this.dataset.procurator.address_street)
      formData.append('procurator_address_number', this.dataset.procurator.address_number)
      if (this.dataset.procurator.address_complement) {
        formData.append('procurator_address_complement', this.dataset.procurator.address_complement)
      }
      formData.append('procurator_address_neighborhood', this.dataset.procurator.address_neighborhood)
      formData.append('procurator_address_city', this.dataset.procurator.address_city)
      formData.append('procurator_address_state', this.dataset.procurator.address_state)

      if (this.dataset.procurator.file) {
        formData.append('procurator_file', this.dataset.procurator.file)
      }
      // if (this.newProcurationFile) {
      //   formData.append('procuration_file', this.newProcurationFile)
      // }

      return formData
    },

    async generateProcurationPdf() {

      const registration = this.dataset.procurator.registration.replace(/[.-]/g, '')
      const now = new Date()
      const day = String(now.getDate()).padStart(2, '0')
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const year = now.getFullYear()
      const footerDate = `${day}${month}${year}`
      const fileName = `procuracao_${registration}_${footerDate}.pdf`
      
      const payload = this.buildProcuratorPayload();

      this.loadingPdf = true
      
      try {
        
        const response = await axios.post('/api/users/create-template-pdf', payload, {
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$dialog.notify.success('PDF gerado com sucesso!')

        await this.$dialog.confirm({
          html: true,
          text: `
            Procuração gerada com sucesso!<br><br>
            O arquivo PDF da procuração foi gerado e salvo na pasta configurada pelo sistema (geralmente a pasta <strong>Downloads</strong>, salvo se houver outra configuração).<br><br>
            Proceda com a assinatura digital através da plataforma <strong>gov.br</strong> e depois envie o documento através do botão disponivel abaixo dos dados do procurador.
          `,
          title: 'Sucesso',
          actions: {
            true: 'OK'
          }
        });

        this.showGenerateProcurationDialog = false;

        //this.router.push('/minha-conta')

      } catch (error) {

        let apiMessage = "Erro ao gerar PDF da procuração!";

        if (
          error &&
          error.response &&
          error.response.data instanceof Blob
        ) {
          try {
            const text = await error.response.data.text(); 
            const json = JSON.parse(text); 

            if (json.message) {
              apiMessage = json.message;
            }
          } catch (parseError) {
            console.error("Erro ao interpretar resposta da API:", parseError);
          }
        } else if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          apiMessage = error.response.data.message;
        } else if (error && error.message) {
          apiMessage = error.message;
        }

        this.$dialog.notify.error(apiMessage, {
          position: 'top-right',
          timeout: 5000
        });

      } finally {
        this.loadingPdf = false;
        this.loadUserInfo();
      }
    },

    async loadText() {
      const result = await axios.get(`/api/dynamic-infos/keys`, {
        params: { keys: 'user-event-anonymous,user-event-logged' }
      })

      if (!result.data.content) return

      let contentUserAnonymous = result.data.content.find((x) => x.key === 'user-event-anonymous')
      let contentUserLogged = result.data.content.find((x) => x.key === 'user-event-logged')

      this.dataset.contentUserAnonymous = contentUserAnonymous ? contentUserAnonymous.value : ''
      this.dataset.contentUserLogged = contentUserLogged ? contentUserLogged.value : ''
    },

    async checkAccess() {
      try {
        const response = await axios.get(`/api/users/check-access`)
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$router.replace('/minha-conta')
          return
        }

        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      }
    },

    onProcurationFileChange(file) {
      this.dataset.procuration_file  = file;
    },

    async searchCep() {
      const cep = this.dataset.procurator.address_postal_code.replace(/\D/g, '')
      if (cep.length !== 8) {
        return
      }

      try {
        const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        const data = response.data

        if (!data.erro) { 
          this.dataset.procurator.address_street = data.logradouro
          this.dataset.procurator.address_neighborhood = data.bairro
          this.dataset.procurator.address_city = data.localidade
          this.dataset.procurator.address_state = data.uf 
        } else {
          this.dataset.procurator.address_street = ''
          this.dataset.procurator.address_neighborhood = ''
          this.dataset.procurator.address_city = ''
          this.dataset.procurator.address_state = null
         
        }
      } catch (error) {
        this.dataset.procurator.address_street = ''
        this.dataset.procurator.address_neighborhood = ''
        this.dataset.procurator.address_city = ''
        this.dataset.procurator.address_state = null
      }
    },

    openDoc(doc) {
      window.open(doc, '_blank')
    },

    async verifyAssociation() {
      const result = await axios.get('/api/user-creditors/association')

      const data = result.data.content

      if (!data || data.length === 0) return

      this.dataset.isAssociationCreditor = true
      this.dataset.userRequestedValue = data[0].amount
    },

    async loadUserInfo() {
      try {
        //const result = await axios.get('/api/users/info')
        //const result = await axios.get('/api/users/info-assicated-lawyer')
        const result = await axios.get('/api/users/my-account-list')

        this.user = result.data.content
        
        if (this.user.registration.length > 11) {
          this.isRegistrationCNPJ = true;
        } else {
          this.isRegistrationCNPJ = false;
        }

        if (this.user.lawyers_user && this.user.lawyers_user.length > 0) {
          this.userLawyerData = this.user.lawyers_user[0]
        }
      
      } catch (error) {
        console.error('Erro ao carregar informações do usuário:', error)
      }
    },

    async updateProcurationFile(){

      if(!this.dataset.procuration_file){
        this.$dialog.notify.error('Por favor, selecione o arquivo da procuração assinada antes de enviar.')
        return;
      }

      const isCompany = this.user.registration.replace(/\D/g, "").length === 14;

      const formData = new FormData();
      formData.append("signed_pdf", this.dataset.procuration_file);
      formData.append("id", this.userLawyerData.id);
      formData.append("lawyerId", this.userLawyerData.lawyer.id); 

      this.loadingPdf = true;
      
      try {
      
        const response = await axios.post('/api/users/upload-template-pdf', formData)

        let successMessage = "";

        if (isCompany) {
          successMessage = `
            Sua assinatura foi considerada válida. <br><br>
            Agora, os Administradores Judiciais procederão à avaliação dos demais documentos necessários 
            para a adequada representação processual. Após, você receberá a confirmação sobre o cadastramento, 
            ou eventual pedido de complementação documental.
          `;
        } else {
          successMessage = `
            Procuração enviada e validada com sucesso!<br><br>
            PRONTO! Agora você poderá solicitar a revisão de seu crédito e/ou aderir ao Plano de Recuperação Judicial.
          `;
        }

        await this.$dialog.confirm({
          html: true,
          text: successMessage,
          title: '✔️ Sucesso',
          actions: {
            true: 'OK'
          }
        });
        
      } catch (error) {
        console.error("Erro ao enviar PDF:", error)

        let apiMessage = 'Erro desconhecido ao enviar o PDF.'

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.content &&
          error.response.data.content.error &&
          error.response.data.content.error.message
        ) {
          apiMessage = error.response.data.content.error.message
        } else if (error && error.message) {
          apiMessage = error.message;
        }
        apiMessage = this.formatProcurationUploadError(apiMessage)
          await this.$dialog.confirm({
            html: true,
            text: apiMessage, 
            title: '❌ Erro!',
            actions: {
              true: 'OK'
            }
          });
        return { error: true, message: apiMessage }
      }finally {
        this.loadingPdf = false;
        this.showUpdateProcurationDialog = false;
        this.dataset.procuration_file = null;
        this.loadUserInfo();
      }
    },

    formatProcurationUploadError(message) {
      const safeMessage = message || 'Erro desconhecido ao enviar o PDF.'
      return `
        <strong>Não foi possível validar a procuração enviada.</strong><br><br>
        ${safeMessage}
      `
    },

    async loadLawyer() {
      try {
        const response = await axios.get('/api/user/laywer')
        this.lawyer = response.data.content

      } catch (error) {
        console.error('Erro ao carregar informações do procurador:', error)
        this.lawyer = null
      }
    },

    async load() {
      const result = await axios.get('/api/user-events/request')
      this.data = result.data.content
      this.processes = []
      this.data.forEach((item) => {
        if (Array.isArray(item.processes) && item.processes.length > 0) {
          this.processes = [...this.processes, ...item.processes]
        }
      })
    },

    formatCpfCnpj(value) {

      if (!value) {
          return ''
      }

      return value.length == 14 ? cnpj.format(value) : cpf.format(value);
    },

    getColorByStatus(status) {
      switch (status) {
        case 0:
          return 'warning'
        case 1:
          return 'green'
        case 2:
          return 'important'
        case 3:
          return 'blue-grey'
        case 4:
          return "deep-orange"
        case 5:
          return "#9C27B0"
        default:
          break
      }
    },

    getTextByStatus(status) {
      switch (status) {
        case 0:
          return 'Pendente'
        case 1:
          return 'Aprovado'
        case 2:
          return 'Rejeitado'
        case 3:
          return 'Removido'
        case 4:
          return "Aguardando procuração";
        case 5:
          return "Atualizar dados procurador";
        default:
          break
      }
    },

    getRepStatusText(status) {
      switch (status) {
        case 0: return 'Pendente'
        case 1: return 'Aprovado'
        case 2: return 'Rejeitado'
        default: return 'Não definido'
      }
    },

    getRepStatusColor(status) {
      switch (status) {
        case 0: return 'warning'
        case 1: return 'success'
        case 2: return 'error'
        default: return 'grey'
      }
    },

    handleLawyerAction(status) {
      this.$router.push('/associacao-procurador')
    },

    getLawyerActionIcon(status) {
      if (status === 4) return "mdi-file-upload";       
      if (status === 5) return "mdi-account-edit";      
    },

    getLawyerActionColor(status) {
      if (status === 4) return "blue darken-2";
      if (status === 5) return "green darken-2";
    },

    getLawyerActionTooltip(status) {
      if (status === 4) return "Enviar documento procuração assinado";
      if (status === 5) return "Atualizar dados do procurador";
    },

    openRejectReason(rep) {
      console.log("Rejection reason:", rep);
      this.selectedRejectReason = rep.reject_reason;
      this.showReasonDialog = true;
    },

  }
}
</script>

<style lang="scss">
.title-page {
  color: var(--v-primary-base);
  font-family: 'Raleway';
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
}

.section-info-title {
  color: var(--v-primary-base);
  font-family: 'Raleway';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.section-info-value {
  font-family: 'Raleway';
  font-size: 14px;
  font-style: normal;
}

.custom-panel-header {
  min-height: 20px !important;
  line-height: 20px !important;
  padding-top: 5 !important;
  padding-bottom: 0 !important;
}

.pulse-attention {
  animation: pulse 1.2s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    filter: brightness(1);
  }
  50% {
    transform: scale(1.25);
    filter: brightness(1.3);
  }
  100% {
    transform: scale(1);
    filter: brightness(1);
  }
}


.main-text {
  font-size: 16px;
  /* Tamanho do texto principal */
  color: #000;
  /* Cor do texto */
}

.caption-text {
  font-size: 12px;
  /* Tamanho da legenda menor */
  font-weight: bold;
  /* Negrito na legenda */
  color: #444;
  /* Cor da legenda */
  margin-top: -5px;
  /* Ajuste de espaçamento entre texto e legenda */
}
</style>
